import { forwardRef, EventEmitter } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';
import { noop } from 'rxjs';
var CHECKBOX_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return UICheckboxComponent; }),
    multi: true
};
var CHECKBOX_VALIDATORS = {
    provide: NG_VALIDATORS,
    useExisting: forwardRef(function () { return UICheckboxComponent; }),
    multi: true
};
var UICheckboxComponent = /** @class */ (function () {
    function UICheckboxComponent() {
        this._onChange = noop;
        this._onTouched = noop;
        this.change = new EventEmitter();
    }
    Object.defineProperty(UICheckboxComponent.prototype, "required", {
        set: function (value) {
            this._required = value !== false;
        },
        enumerable: true,
        configurable: true
    });
    UICheckboxComponent.prototype._onClick = function (event) {
        this._toggle(event);
    };
    UICheckboxComponent.prototype._onSpaceDown = function (event) {
        this._toggle(event);
    };
    UICheckboxComponent.prototype._onSpacebarDown = function (event) {
        this._toggle(event);
    };
    UICheckboxComponent.prototype._toggle = function (event) {
        if (this.disabled === undefined) {
            this.checked = !this.checked;
            this._onChange(this.checked);
            this._onTouched();
            this.change.emit(event);
        }
    };
    UICheckboxComponent.prototype.writeValue = function (value) {
        this.checked = value;
    };
    UICheckboxComponent.prototype.registerOnChange = function (fn) {
        this._onChange = fn;
    };
    UICheckboxComponent.prototype.registerOnTouched = function (fn) {
        this._onTouched = fn;
    };
    UICheckboxComponent.prototype.setDisabledState = function (disabled) {
        this.disabled = disabled;
    };
    UICheckboxComponent.prototype.validate = function (control) {
        if (!this._required || this.checked) {
            return null;
        }
        return { required: { valid: false } };
    };
    return UICheckboxComponent;
}());
export { UICheckboxComponent };
